import { Injectable } from '@angular/core';
import Cookies from 'js-cookie';

export const STORAGE_KEYS = {
  LANGUAGE: 'AC-LANGUAGE',
  RECENT_INPUT: 'AC-RECENT-INPUT',
  USER: 'AC-VERIFIER',
  IMPERSONATION_TOKEN: 'AC-IMPERSONATION-TOKEN',
  ENERGY_REHABILITATION_MODE: 'AC-ENERGY-REHABILITATION-MODE',
  IDP: 'IDP',
  REDIRECT: 'AC-REDIRECT',
  REDIRECT_EXPIRY: 'AC-REDIRECT-EXPIRY',
  COUNTRY: 'AC-COUNTY',
};

type StorageType = 'local' | 'session' | 'cookie';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private readonly _cookies = Cookies.withAttributes({
    sameSite: 'strict',
    secure: true,
  });

  public getItem(key: string, storageType: StorageType = 'local') {
    switch (storageType) {
      case 'session':
        return window.sessionStorage.getItem(key);
      case 'cookie':
        return this._cookies.get(key) ?? null;
      case 'local':
      default:
        return window.localStorage.getItem(key);
    }
  }

  public setItem(key: string, value: string, storageType: StorageType = 'local') {
    switch (storageType) {
      case 'local':
        window.localStorage.setItem(key, value);
        break;
      case 'session':
        window.sessionStorage.setItem(key, value);
        break;
      case 'cookie':
        this._cookies.remove(key);
        this._cookies.set(key, value);
        break;
    }
  }

  public removeItem(key: string, storageType: StorageType = 'local') {
    switch (storageType) {
      case 'local':
        window.localStorage.removeItem(key);
        break;
      case 'session':
        window.sessionStorage.removeItem(key);
        break;
      case 'cookie':
        this._cookies.remove(key);
        break;
    }
  }
}
